import styled from 'styled-components'

export const CreateAndEditContainer = styled.div``
